<script setup>
import { ref, computed } from 'vue';
import { Link } from '@inertiajs/vue3';
import BlogCard from './BlogCard.vue';

const props = defineProps({
    web_site: Object,
    blog_posts: Array,
    blog_count: Number,
    preview: Boolean
});

const color = ref(props.web_site.color)
// Compute grid classes dynamically
const gridCols = computed(() => {
    const count = props.blog_posts.length;
    if (count === 1) return 'grid-cols-1 lg:grid-cols-1';
    if (count === 2) return 'grid-cols-1 lg:grid-cols-2';
    if (count === 3) return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
    return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4';
});
</script>
<template>
    <section id="publicacoes" aria-labelledby="recent-posts-heading" class="bg-white px-5 py-12 md:py-14">
        <div class="mb-6 text-center">
            <h2 id="recent-posts-heading" class="text-2xl font-bold text-[#3f444a] md:text-3xl">{{ $t('recent_posts') }}</h2>
            <div class="mt-1 flex items-center justify-center gap-3">
                <span class="h-0.5 w-5 rounded-full" :style="{ backgroundColor: color }"></span>
                <p class="text-sm text-[#5c6873]">{{ $t('recent_posts_subtitle') }}</p>
                <span class="h-0.5 w-5 rounded-full" :style="{ backgroundColor: color }"></span>
            </div>
        </div>

        <div class="container mx-auto mt-6 grid gap-8" :class="gridCols">
            <div v-for="blog in blog_posts" :key="blog.id" class="mx-auto max-w-sm w-full">
                <BlogCard :web_site="web_site" :blog="blog" :preview="preview" />
            </div>
        </div>

        <div class="w-full flex justify-center mt-6">
            <Link :href="route('blog.post.list', { user: web_site.page_url, ...(preview ? { preview: 1 } : {}) })"
                class="rounded-full border px-5 py-2 text-sm font-semibold uppercase"
                :style="{ color, borderColor: color }">
                {{ $t('view_more_publications') }}
            </Link>
        </div>
    </section>

</template>
